/* eslint-disable react/no-array-index-key */
import React from 'react';

interface ContentHighlighterProps {
  text: string;
  bolded: string;
}

const ContentHighlighter = (props: ContentHighlighterProps) => {
  const getHighlightedText = (text: string, highlight: string) => {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <span>
        {parts.map((part, i) => (
          <span key={i} style={i % 2 === 1 ? { fontWeight: 'bold' } : {}}>
            {part}
          </span>
        ))}
      </span>
    );
  };

  return getHighlightedText(props.text, props.bolded);
};

export default ContentHighlighter;
